<template>
  <div
    class="item"
    :class="{ 'is-matched': matched }"
  >
    <div
      v-if="icon"
      class="item-icon"
      v-html="icon"
    />
    <span>{{ name }}</span>
  </div>
</template>

<script>
export default {
  name: 'amenity',
  props: {
    matched: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped lang="scss">
.item {
  display: flex;
  align-items: flex-end;
  font-weight: 700;
  color: #6e7c91;

  &.is-matched {
    color: #e48616;
  }
  &.is-matched &-icon {color: #e48616;}

  &-icon {
    margin-right: 14px;
    width: 18px;
    height: 18px;
    position: relative;
    color: #32325a;

    & > * {
      position: absolute;
      z-index: 1;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
    }
  }
}
</style>
